/* EMM — pre-warm product-card sliders.
   The theme initializes each card's image slider only on first hover
   (after lazy-loading the Swiper library), so the first hover shows
   prev/next arrows with a noticeable delay. With a 2-product catalog the
   lazy win is negligible — initialize them at idle instead. */
(function () {
  'use strict';
  function go() {
    document.querySelectorAll('.product-card').forEach(function (c) {
      c.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
    });
  }
  function warm() {
    if (window.requestIdleCallback) {
      requestIdleCallback(go, { timeout: 2000 });
    } else {
      setTimeout(go, 600);
    }
  }
  if (typeof Swiper === 'function') {
    warm();
  } else {
    window.addEventListener('swiperLoaded', warm, { once: true });
  }
})();
